/* Public parcel tracking page for the end client: status + tracking only (no prices, no products). */
import { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle2, ExternalLink, Loader2, PackageCheck, Truck } from "lucide-react";
import { PORTAL_API } from "./portalApi";

const STEPS = [["pending", "Order received"], ["in_process", "Being prepared"], ["completed", "Dispatched"]];

export default function PortalTrackPage() {
  const token = window.location.pathname.split("/t/")[1]?.split(/[/?#]/)[0] || "";
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    document.title = "Parcel tracking";
    axios.get(`${PORTAL_API}/public/track/${encodeURIComponent(token)}`).then((r) => setD(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "This tracking link is not active"));
  }, [token]);
  const at = d ? STEPS.findIndex(([k]) => k === d.status) : -1;
  return (
    <div className="min-h-screen bg-[#f3f5f4] px-4 py-10" data-testid="track-page">
      <div className="mx-auto max-w-md space-y-4">
        <div className="flex items-center gap-2 text-[#0f1c2e]"><PackageCheck className="h-6 w-6 text-teal-600" /><b>Parcel tracking</b></div>
        {!d && !err && <div className="py-10 text-center text-slate-400"><Loader2 className="mx-auto h-5 w-5 animate-spin" /></div>}
        {err && <p className="rounded-2xl border bg-white p-6 text-center text-sm text-slate-500" data-testid="track-error">{err}</p>}
        {d && (
          <div className="space-y-5 rounded-2xl border bg-white p-6 shadow-sm">
            <div><p className="text-xs text-slate-400">Parcel for</p><p className="text-lg font-bold" data-testid="track-for">{d.for || "—"}</p>
              <p className="text-xs text-slate-500">{d.mode}{d.date && ` · ordered ${new Date(`${d.date}T00:00:00`).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}`}</p></div>
            {d.status === "cancelled" ? <p className="rounded-lg bg-rose-50 p-3 text-sm font-semibold text-rose-700" data-testid="track-status">This parcel was cancelled.</p> : (
              <ol className="space-y-3" data-testid="track-status">{STEPS.map(([k, l], i) => (
                <li key={k} className={`flex items-center gap-3 text-sm ${i <= at ? "font-semibold text-slate-800" : "text-slate-400"}`}>
                  {i <= at ? <CheckCircle2 className="h-5 w-5 text-teal-600" /> : <span className="h-5 w-5 rounded-full border-2" />}{l}</li>))}</ol>)}
            {d.tracking ? (
              <div className="rounded-xl bg-slate-50 p-4">
                <p className="text-xs text-slate-400">Tracking number</p>
                <p className="font-mono text-lg font-bold tracking-wider" data-testid="track-number">{d.tracking}</p>
                <a href={`https://www.ship24.com/tracking?p=${encodeURIComponent(d.tracking)}`} target="_blank" rel="noreferrer"
                  className="mt-3 inline-flex items-center gap-2 rounded-lg bg-[#0f1c2e] px-4 py-2 text-sm font-semibold text-white" data-testid="track-ship24-link">
                  <Truck className="h-4 w-4" /> Live tracking on Ship24 <ExternalLink className="h-3.5 w-3.5" /></a>
                <p className="mt-2 text-[11px] text-slate-400">Live updates appear once the post office scans the parcel.</p>
              </div>) : <p className="text-sm text-slate-500">The tracking number will appear here once it is ready.</p>}
          </div>)}
      </div>
    </div>
  );
}
